<script setup lang="ts">
import { computed } from "vue";
import ScaleMenuState from "@/stores/ScaleMenuState";
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

/**
 * Contenu du bouton Échelle de l'en-tête. Partagé par le vrai bouton et par sa
 * copie invisible qui sert à mesurer la place nécessaire.
 */
const activeScaleName = computed(() => ScaleMenuState.activeScale?.name ?? "-");
</script>

<template>
  <span class="chip-caption">{{ $t("canvas:header.scale.label") }}</span>
  <span class="chip-value text-truncate">{{ activeScaleName }}</span>
  <span v-if="ScaleMenuState.hasForcedSize()" class="chip-caption">
    · {{ ScaleMenuState.forcedSize }}
  </span>
  <PhosphorIcon name="caret-down" :size="11" weight="fill" />
</template>

<style lang="scss" scoped>
.chip-value {
  max-width: 120px;
  font-weight: 600;
}
</style>
